import { render, staticRenderFns } from "./social-login.vue?vue&type=template&id=64319df2&scoped=true"
import script from "./social-login.vue?vue&type=script&setup=true&lang=js"
export * from "./social-login.vue?vue&type=script&setup=true&lang=js"
import style0 from "./social-login.vue?vue&type=style&index=0&id=64319df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64319df2",
  null
  
)

export default component.exports